import { Consumables } from "./type";
import imgCatelog from "@/assets/img/catelog";

const consumablesPools = new Map();
export const consumablesType = {
  FIXEDHEAL: "FIXEDHEAL",
  PERCENTAGEHEAL: "PERCENTAGEHEAL",
  SURPRISEGIFT: "SURPRISEGIFT"
};
const consumablesList: ConsumablesPackItem[] = [
  {
    id: -1,
    name: "小红药",
    img: imgCatelog.item[0],
    value: 50,
    useType: consumablesType.FIXEDHEAL,
    price: 10,
    grade: 0
  },
  {
    id: -2,
    name: "章鱼烧",
    img: imgCatelog.item[8],
    value: 0.3,
    useType: consumablesType.PERCENTAGEHEAL,
    price: 1000,
    grade: 2
  },
  {
    id: -3,
    name: "中红药",
    img: imgCatelog.item[1],
    value: 100,
    useType: consumablesType.FIXEDHEAL,
    price: 30,
    grade: 0
  }

  // 惊喜蛋 https://s.aigei.com/src/img/png/63/631c6bd1586d48b09e0ce18b0e5cb8d8.png?imageMogr2/auto-orient/thumbnail/!27x27r/gravity/Center/crop/27x27/quality/85/&e=1735488000&token=P7S2Xpzfz11vAkASLTkfHN7Fw-oOZBecqeJaxypL:Ycv3FNwbmZATohX_klLUsZ7fmCE=
];

consumablesList.forEach(m => {
  consumablesPools.set(m.name, new Consumables(m));
});

export default consumablesPools;
